import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import CmtListItem from "src/components/notice/CmtListItem";
import { useAppSelector } from "../../store/actions/action";
import { useFulfillDetailQuery, useModifyRedeemRegisterMutation, useRedeemRegisterMutation } from "../../api/fulfillAPI";
import { cloneDeep, parseInt } from "lodash";
import { setToggleData } from "../../store/reducers/toggleReduce";
import { useDispatch } from "react-redux";
import { useGetS3UrlMutation, useGetOftenUsePhrasesQuery } from "../../api/noticeAPI";
import { RotatingLines } from "react-loader-spinner";
import { setRedeemData, setRedeemDataAllInit } from "../../store/reducers/redeemReduce";
import { lPad } from "src/utils/lPad";


function redeemRequest() {
  const modifyMode: "MODIFY" | "REREDEEM" | undefined = (useLocation() as any).state?.mode;
  const originalId: number = (useLocation() as any).state?.originalId;
  const navigate = useNavigate();
  const redeemData = useAppSelector((state) => state.redeemReduce);
  const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
  const fulfillDetail = useFulfillDetailQuery(redeemData.fulfillId, { skip: redeemData.fulfillId === (undefined || null || "") });
  const [getS3Urls] = useGetS3UrlMutation();
  const { data: oftenUsePhrases = [] } = useGetOftenUsePhrasesQuery(undefined);
  const dispatch = useDispatch();

  const [redeemList, setRedeemList] = useState<Redeem[]>(() => {
    const initData = Array.from({ length: redeemData.imageList.length }, (v, i) => ({
      id: i,
      originalFile: redeemData.imageList[i],
      modifyFile: redeemData.modifiedList[i] ?? undefined,
      text: redeemData.context ?? "",
    }));
    return initData;
  });

  //221027 2. 저장된 text 초기화
  useEffect(() => {
    redeemData.redeemData.forEach((saved) => {
      saved.text !== "" &&
        redeemList.map((element) => {
          if (element.originalFile.img_origin_name == saved.imageName) return (element.text = saved.text);
        });
    });
  }, []);
  //221027 1. 이미지별 text 저장
  useEffect(() => {
    const temp: ImageWithText[] = redeemList.map((redeem) => {
      return { imageName: redeem.originalFile.img_origin_name, text: redeem.text };
    });
    dispatch(setRedeemData({ redeemData: temp }));
  }, [redeemList]);

  const [favoriteTarget, setFavoriteTarget] = useState(0);
  const [redeemRegister] = useRedeemRegisterMutation();
  const [modifyRedeemRegister] = useModifyRedeemRegisterMutation();
  const [sending, setSending] = useState(false);
  const cmtModalRef = React.useRef<RefProps>(null);
  const saveFileImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectFile = e.target.files![0];
    const tempTargetId = e.target.id.split("-");
    const targetId = parseInt(tempTargetId[tempTargetId.length - 1]);
    const temp = cloneDeep(redeemList);
    temp[targetId].modifyFile = selectFile;
    setRedeemList(temp);
  };

  const deleteFileImage = (index: number) => {
    const deleteImageList = cloneDeep(redeemList);
    deleteImageList[index].modifyFile = undefined;
    setRedeemList(deleteImageList);
  };

  const openCmtModal = (index: number) => {
    setFavoriteTarget(index);
    if (cmtModalRef.current) cmtModalRef.current.modalOpen();
  };

  function textChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    const index = parseInt(e.target.name);
    const modifyText = cloneDeep(redeemList);
    modifyText[index].text = e.target.value;
    setRedeemList(modifyText);
  }

  function listClick(index: number) {
    const modifyText = cloneDeep(redeemList);
    modifyText[favoriteTarget].text = modifyText[favoriteTarget].text + oftenUsePhrases[index]?.phrase || "";
    setRedeemList(modifyText);
    if (cmtModalRef.current) cmtModalRef.current.modalClose();
  }

  function back() {
    navigate(-1);
  }
  //noticeRegister
  async function getS3Url(fileList: (File | undefined)[]) {
    let result: S3Data[] = [];
    const dataList: { originalFileName: string; contentType: string; size: number }[] = [];
    fileList.forEach((file) => {
      file !== undefined && dataList.push({ originalFileName: (file as File).name, contentType: (file as File).type, size: (file as File).size });
    });
    const response: any = await getS3Urls({ data: dataList });
    result = await response.data.data;
    return result;
  }
  //noticeRegister
  async function upLoadFile(files: (File | undefined)[], s3DataList: S3Data[]) {
    const noUndeFile = files.filter((temp) => temp != undefined);
    const fileCount = noUndeFile.length;
    let successCount = 0;
    let result = false;
    for (const file of noUndeFile) {
      const index = noUndeFile.indexOf(file);
      const response = await fetch(s3DataList[index].uploadURL, { method: "PUT", headers: { "Content-Type": (file as File).type }, body: file as File });
      (await response.ok) && successCount++;
    }
    if (successCount === fileCount) result = true;
    return result;
  }

  async function register() {
    if (redeemList.find((redeem) => redeem.text == "")) {
      return alert("내용을 입력해 주세요.");
    }
    setSending(true);
    try {
      const fileList = redeemList.map((redeem) => redeem.modifyFile);
      const fileListNoUndefind = fileList.filter((noUndi) => noUndi !== undefined);
      dispatch(setToggleData({ mode: "SENDING", data: "재이행 요청중입니다." }));
      let s3UrlList: S3Data[] = [];
      if (fileListNoUndefind.length > 0) {
        const s3Urls = await getS3Url(fileList as File[]);
        const sendS3Data = await upLoadFile(fileList as File[], s3Urls);
        if (sendS3Data) s3UrlList = await s3Urls;
        else throw "[E02]";
      }
      const redeemApiData: RedeemApi[] = [];
      for (let i = 0; i < redeemList.length; i++) {
        const temp: RedeemApi = {
          deficient_img_idx: redeemList[i].originalFile.img_idx,
          deficient_reason: redeemList[i].text,
        };
        if (modifyMode == "REREDEEM") temp.origin_img_idx = originalId;
        if (redeemList[i].modifyFile !== undefined) {
          const s3Url = s3UrlList.find((s3) => s3.originalFileName == (redeemList[i].modifyFile as File)?.name);
          if (s3Url) {
            temp.file_origin_name = s3Url.originalFileName;
            temp.file_name = s3Url.fileName;
            temp.file_url = s3Url.path;
            temp.ext = s3Url.ext;
          }
        }
        redeemApiData.push(temp);
      }
      const result: any = await redeemRegister({ redeemId: redeemData.fulfillId, data: redeemApiData });
      if (result.data.message === "success") {
        setSending(false);
        dispatch(setRedeemDataAllInit());
        dispatch(setToggleData({ mode: "SUCCESS", data: "재이행 요청 완료." }));
        navigate(-2);
      } else {
        throw "[E03]";
      }
    } catch (err) {
      dispatch(setToggleData({ mode: "ERROR", data: "재이행 요청 실패." }));
      setSending(false);
    }
  }

  async function modifyRegister() {
    if (redeemList.find((redeem) => redeem.text == "")) {
      return alert("내용을 입력해 주세요.");
    }
    setSending(true);
    try {
      dispatch(setToggleData({ mode: "SENDING", data: "재이행 수정중입니다." }));
      const form = new FormData();
      //210921 wjp 재이행 수정시 파일이 있으면 추가하고, 아무것도 없으면 삭제한다. {IMAGE} 타입은 url 이미지임.
      (redeemList[0].modifyFile as File)?.name && form.append("image", redeemList[0].modifyFile as File);
      redeemList[0].modifyFile == undefined && form.append("delete_img_yn", "Y");
      form.append("deficient_reason", redeemList[0].text);
      const result: any = await modifyRedeemRegister({ reRedeemId: redeemData.modifyId, data: form });
      if (result.data.message === "success") {
        setSending(false);
        dispatch(setRedeemDataAllInit());
        dispatch(setToggleData({ mode: "SUCCESS", data: "재이행 수정 완료." }));
        navigate(-1);
      } else {
        throw "[E03]";
      }
    } catch (err) {
      console.error(err);
      dispatch(setToggleData({ mode: "ERROR", data: "재이행 수정 실패." }));
      setSending(false);
    }
  }

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => back()}>
            재이행 요청
          </Button>
        </div>
        <div className="btn-box">
          {sending ? (
            <p style={{ textAlign: "center" }}>
              <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
            </p>
          ) : (
            <Button variant="text" onClick={modifyMode === "MODIFY" ? () => modifyRegister() : () => register()}>
              {modifyMode === "MODIFY" ? "수정" : "등록"}
            </Button>
          )}
        </div>
      </header>
      <Body type="detail">
        <TitleBox>
          <div>
            <p className="cate">{fulfillDetail.data?.notice_category_name ? fulfillDetail.data.notice_category_name : ""}</p>
            <p className="title">{fulfillDetail.data?.notice_title ? fulfillDetail.data.notice_title : ""}</p>
          </div>
          <div>
            <p>총 {redeemList.length}건</p>
          </div>
        </TitleBox>

        <UlList>
          {redeemList.map((res, index) => (
            <li>
              <CustomNumbering>
                <span>{lPad(index + 1, 2, 0)}</span>
                {lPad(redeemList.length, 2, 0)}
              </CustomNumbering>

              <UploadRedeemImg>
                <div>
                  <div className="img-box">
                    <img src={imageServerIp + res.originalFile.img_url} alt="더미이미지" />
                  </div>
                </div>
                <div>
                  {redeemList[index]?.modifyFile ? (
                    <PreviewImg>
                      {(redeemList[index]?.modifyFile as File).name ? (
                        <div>
                          <img src={URL.createObjectURL((redeemList[index].modifyFile as File)!)} alt="더미이미지" />
                        </div>
                      ) : (
                        <div>
                          <img alt="sample" src={imageServerIp + (redeemList[index].modifyFile as Image).img_url} />
                        </div>
                      )}
                      <IconButton btnName="미리보기 삭제하기" onClick={() => deleteFileImage(index)}>
                        <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
                      </IconButton>
                    </PreviewImg>
                  ) : (
                    <label htmlFor={`redeem-file-${index}`}>
                      <span className="hidden">파일업로드</span>
                      <input
                        id={`redeem-file-${index}`}
                        type="file"
                        accept="image/*"
                        name={"redeem-img-" + index}
                        onChange={(e) => {
                          saveFileImage(e);
                        }}
                      />
                    </label>
                  )}
                </div>
              </UploadRedeemImg>
              <div className="cmt-box">
                <div className="cmt-box-header">
                  <button onClick={() => openCmtModal(index)}>자주 쓰는 문구 선택</button>
                  <button onClick={() => navigate("/settings/phrases")}>자주 쓰는 문구 설정</button>
                </div>
                <textarea
                  name={index.toString()}
                  placeholder={"재이행에 대한 내용을 작성해주세요!"}
                  value={redeemList[index].text}
                  onChange={(e) => textChange(e)}
                />
              </div>
            </li>
          ))}
        </UlList>
      </Body>

      <BottomModal modalTitle="자주 쓰는 문구" ref={cmtModalRef}>
        <CmtListItem favoriteContent={oftenUsePhrases.map((phrase: any) => phrase.phrase)} onClick={listClick} />
      </BottomModal>
    </>
  );
}

const TitleBox = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-end")}
  padding: 30px 0 16px;
  margin: 0 15px 40px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  > div {
    .cate {
      font-size: 12px;
    }
    .title {
      padding-top: 8px;
      color: #000000;
      font-size: 16px;
      font-weight: 700;
    }
    &:last-child {
      flex: 1 0 auto;
      flex-basis: 50px;
      font-size: 12px;
      text-align: right;
    }
  }
`;

const CustomNumbering = styled.div`
  padding: 0 15px;
  color: ${({ theme }) => theme.color.quaternary};
  font-family: "Poppins";
  font-size: 12px;
  font-weight: 400;
  text-align: right;
  > span {
    position: relative;
    display: inline-block;
    padding-right: 8px;
    margin-right: 8px;
    color: ${({ theme }) => theme.color.main};
    font-weight: 700;
    &:after {
      content: "";
      display: block;
      position: absolute;
      right: -1px;
      top: 50%;
      width: 2px;
      height: 12px;
      margin-top: -6px;
      border-radius: 1px;
      background: ${({ theme }) => theme.color.lineSecondary};
    }
  }
`;

const UlList = styled.ul`
  > li {
    margin-bottom: 40px;
    /* counter-increment: group;
    counter-reset: row 1;
    &:before {
      content: counter(group);
      display: inline-block;
      padding-left: 15px;
    } */
    .cmt-box {
      padding: 0 15px;
      text-align: right;
      .cmt-box-header {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
        margin-bottom: 8px;
      }
      > button,
      .cmt-box-header > button {
        display: inline-block;
        padding: 5px 15px;
        border: 1px solid ${({ theme }) => theme.color.linePrimary};
        border-radius: 14px;
        background: none;
        color: ${({ theme }) => theme.color.tertiary};
        font-size: 14px;
        appearance: none;
        cursor: pointer;
        
        &:hover {
          background: ${({ theme }) => theme.color.linePrimary};
        }
      }
      > textarea {
        width: 100%;
        height: 160px;
        padding: 12px 15px;
        border: none;
        border-radius: 4px;
        margin-top: 8px;
        background: ${({ theme }) => theme.color.bgPrimary};
        color: ${({ theme }) => theme.color.primary};
        font-size: 16px;
        line-height: 20px;
        resize: none;
        &::placeholder {
          color: ${({ theme }) => theme.color.tertiary};
          font-size: 14px;
        }
        &:focus {
          outline: none;
        }
      }
    }
  }
`;

const UploadRedeemImg = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "stretch")}
  margin: 16px 0 8px 15px;
  > div {
    width: 50%;
    font-size: 0;
    padding-right: 15px;
    &:first-child {
      .img-box {
        ${({ theme }) => theme.imgBox.coverBox()}
      }
    }
    &:last-child {
      > label {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        border: 1px dashed ${({ theme }) => theme.color.lineSecondary};
        &:before {
          position: absolute;
          top: 50%;
          left: 50%;
          content: "";
          display: block;
          width: 1px;
          height: 19px;
          margin-top: -9px;
          background-color: ${({ theme }) => theme.color.lineSecondary};
        }
        &:after {
          position: absolute;
          top: 50%;
          left: 50%;
          content: "";
          display: block;
          width: 19px;
          height: 1px;
          margin-left: -9px;
          background-color: ${({ theme }) => theme.color.lineSecondary};
        }
        > input {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          border: 0;
        }
      }
    }
  }
`;

const PreviewImg = styled.div`
  position: relative;
  > div {
    ${({ theme }) => theme.imgBox.coverBox()}
  }
  > button {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`;

export default redeemRequest;
